import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Danhmucxedien from "components/Danhmuc/Xedien/Danhmucxedien.js";
export default function Dmtuyenxe() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Danh mục xe điện",
            tabContent: <Danhmucxedien />,
          },
        ]}
      />
    </div>
  );
}
